import React from "react";

import { FiCalendar } from "react-icons/fi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomDateInput = ({
  value = "",
  onChange,
  disabled = false,
  name = "",
  placeholder = "Select Date",
  maxDate = new Date(),
  minDate = null,
  className = "",
  width = "w-[70%]",
  showIcon = true,
  required = false,
  error = "",
  label = "",
}) => {
  const selectedDate = value ? new Date(value) : null;

  const handleChange = (date) => {
    onChange({
      target: {
        name,
        value: date ? date.toISOString().split("T")[0] : "",
      },
    });
  };
  

  // Calendar container with bottom positioning
  const CustomPopperContainer = ({ children }) => {
    return <div className="absolute top-full left-0 mt-1 z-40">{children}</div>;
  };

  return (
    <div className={`${width} ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <DatePicker
          selected={selectedDate}
          onChange={handleChange}
          placeholderText={placeholder}
          dateFormat="dd/MM/yyyy"
          maxDate={maxDate}
          minDate={minDate}
          disabled={disabled}
          popperPlacement="bottom"
          popperContainer={CustomPopperContainer}
          popperModifiers={{
            preventOverflow: {
              enabled: false,
            },
            flip: {
              enabled: false,
            },
          }}
        //   className={`w-full py-2 px-4 ${showIcon ? 'pr-12' : 'pr-4'} border-2 transition-all input-focus duration-200 ease-in-out
        //     ${error 
        //       ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200' 
        //       : disabled 
        //         ? 'border-gray-300 bg-gray-100 text-gray-400 cursor-not-allowed' 
        //         : ''
        //     } 
        //     rounded-lg text-gray-700 placeholder-gray-400 focus:outline-none bg-white`}
        className="w-full py-2 px-4 pr-12 border-2 transition-all input-focus duration-200 ease-in-out"
          wrapperClassName="w-full"
          required={required}
        />
        {showIcon && (
          <FiCalendar 
            className={`absolute right-4 top-1/2 transform -translate-y-1/2 w-5 h-5 
              ${error 
                ? 'text-red-500' 
                : disabled 
                  ? 'text-gray-400' 
                  : 'text-gray-500 hover:text-customGreen'
              } 
              pointer-events-none transition-colors duration-200`} 
          />
        )}
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600 flex items-center">
          <span className="mr-1">⚠</span>
          {error}
        </p>
      )}
    </div>
  );
};

export default CustomDateInput;
